import { Component } from '@angular/core';

@Component({
  selector: 'app-selectable-card-showcase',
  templateUrl: './selectable-card-showcase.component.html',
  styleUrls: ['./selectable-card-showcase.component.scss']
})
export class SelectableCardShowcaseComponent {
  // Single selection example
  selectedSeller: string = 'individual';

  // Multiple cards example
  selectedClaimType: string = 'pop';

  sellerOptions = [
    {
      value: 'individual',
      label: 'Seller Individuals',
      description: 'For individual sellers or sole proprietors managing their own sales'
    }
  ];

  claimTypeOptions = [
    {
      value: 'quick',
      label: 'Quick Claiming',
      description: 'Selected by default and highly recommended (especially for Partner companies with less than 50 Sellers), the Quick Claiming option requires no data input by its users (Sellers or Company Admins) allowing for fast and easy claiming.\n\nWith this option, the Company agrees to have Sellers submit claims individually, or Company Admins to submit claims in bulk for a list of your Company\'s eligible shipped sales. This option requires no further validation, resulting in the immediate award and issuance of Rewards points to the Company, to then be distributed (automatically or manually) to Sellers.'
    },
    {
      value: 'pop',
      label: 'POP Claiming',
      description: 'Especially recommended for Partner companies with more than 50 Sellers, the Proof of Purchase (POP) Claiming option requires its users (Sellers) to know and provide the proof (Reseller to Distributor Purchase Order Number, or PO Number for Cisco direct sales) needed to validate submitted sales claims.\n\nWith this option, the Company agrees to have Sellers submit claims by providing the required sales info needed in order to find, validate and award points accordingly. While sales validation can take up to 60 days after the submission of the claim, once validated successfully, Rewards points are awarded and issued to the Company, to then be automatically distributed to Sellers.'
    }
  ];

  accountTypeOptions = [
    {
      value: 'business',
      label: 'Business Account',
      description: 'Full-featured business seller account with analytics and reporting',
      icon: 'business'
    },
    {
      value: 'individual',
      label: 'Individual Account',
      description: 'Simple account for individual sellers or part-time vendors',
      icon: 'person'
    },
    {
      value: 'enterprise',
      label: 'Enterprise Account',
      description: 'Enterprise-grade account with dedicated support and advanced features',
      icon: 'domain'
    },
    {
      value: 'marketplace',
      label: 'Marketplace Account',
      description: 'Multi-vendor marketplace management with commission tracking',
      icon: 'store'
    }
  ];

  onSellerChange(value: any): void {
    this.selectedSeller = value;
  }

  onClaimTypeChange(value: any): void {
    this.selectedClaimType = value;
  }

  onAccountTypeChange(value: any): void {
    // Handle account type change
  }

  codeExample = `<!-- Parent component with radiogroup role -->
<div role="radiogroup">
  <app-selectable-card
    *ngFor="let option of options"
    [value]="option.value"
    [label]="option.label"
    [description]="option.description"
    [icon]="option.icon"
    [selected]="selectedValue === option.value"
    (selectionChange)="onSelectionChange($event)"
  ></app-selectable-card>
</div>

<!-- Component TypeScript -->
export class MyComponent {
  selectedValue: string = 'option-1';

  options = [
    {
      value: 'option-1',
      label: 'Option 1',
      description: 'Description for option 1',
      icon: 'check_circle'
    },
    {
      value: 'option-2',
      label: 'Option 2',
      description: 'Description for option 2',
      icon: 'info'
    }
  ];

  onSelectionChange(value: any): void {
    this.selectedValue = value;
  }
}`;
}
